import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createClassNames, translatable } from 'react-instantsearch-dom';
import { STATE_CONTEXT } from './Provider';
import withGoogleMaps from './withGoogleMaps';
var cx = createClassNames('GeoSearch');
export var Control = /*#__PURE__*/
function (_Component) {
  _inherits(Control, _Component);
  function Control() {
    _classCallCheck(this, Control);
    return _possibleConstructorReturn(this, _getPrototypeOf(Control).apply(this, arguments));
  }
  _createClass(Control, [{
    key: "getStateContext",
    value: function getStateContext() {
      return this.context[STATE_CONTEXT];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        googleMapsInstance = _this$props.googleMapsInstance,
        translate = _this$props.translate;
      var _this$getStateContext = this.getStateContext(),
        isRefineOnMapMove = _this$getStateContext.isRefineOnMapMove,
        hasMapMoveSinceLastRefine = _this$getStateContext.hasMapMoveSinceLastRefine,
        toggleRefineOnMapMove = _this$getStateContext.toggleRefineOnMapMove,
        refineWithInstance = _this$getStateContext.refineWithInstance;
      return React.createElement("div", {
        className: cx('control')
      }, isRefineOnMapMove || !hasMapMoveSinceLastRefine ? React.createElement("label", {
        className: cx('label')
      }, React.createElement("input", {
        className: cx('input'),
        type: "checkbox",
        checked: isRefineOnMapMove,
        onChange: toggleRefineOnMapMove
      }), translate('control')) : React.createElement("button", {
        className: cx('redo'),
        onClick: function onClick() {
          return refineWithInstance(googleMapsInstance);
        }
      }, translate('redo')));
    }
  }]);
  return Control;
}(Component);
_defineProperty(Control, "propTypes", {
  googleMapsInstance: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired
});
_defineProperty(Control, "contextTypes", _defineProperty({}, STATE_CONTEXT, PropTypes.shape({
  isRefineOnMapMove: PropTypes.bool.isRequired,
  toggleRefineOnMapMove: PropTypes.func.isRequired,
  hasMapMoveSinceLastRefine: PropTypes.bool.isRequired,
  refineWithInstance: PropTypes.func.isRequired
}).isRequired));
export default translatable({
  control: 'Search as I move the map',
  redo: 'Redo search here'
})(withGoogleMaps(Control));